import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { Brain, Headphones, Pill, Clock } from 'lucide-react';
export function SolutionSection() {
  const failures = [{
    icon: Brain,
    title: 'Meditación',
    desc: 'Si la mente está acelerada, el silencio la hace gritar más fuerte.'
  }, {
    icon: Headphones,
    title: 'Apps y audios',
    desc: 'Ayudan a distraer, pero no sueltan la armadura del pecho ni el apretón de mandíbula.'
  }, {
    icon: Pill,
    title: 'Pastillas',
    desc: 'A veces apagan el síntoma… y también te apagan a vos.'
  }, {
    icon: Clock,
    title: 'Terapia/masaje',
    desc: 'Valiosos, sí. Pero no están ahí cuando son las 11 pm y te estás por ir de vos.'
  }];
  return <section className="py-20 md:py-32 px-6 bg-cream-100" data-id="element-171">
      <div className="max-w-2xl mx-auto mb-24" data-id="element-172">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-serif font-bold text-charcoal mb-12 text-center" data-id="element-173">
          Por qué lo que intentaste te falla
        </motion.h2>

        <div className="grid gap-8" data-id="element-174">
          {failures.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex gap-4 md:gap-6 items-start p-6 bg-white rounded-xl shadow-sm border border-terracotta/10" data-id="element-175">
              <div className="bg-cream-200 p-3 rounded-full text-terracotta-dark shrink-0" data-id="element-176">
                <item.icon className="w-6 h-6" data-id="element-177" />
              </div>
              <div data-id="element-178">
                <h3 className="font-bold text-lg text-charcoal mb-2" data-id="element-179">
                  {item.title}
                </h3>
                <p className="text-charcoal-light leading-relaxed" data-id="element-180">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-xl md:text-2xl font-serif italic text-center text-charcoal mt-16" data-id="element-181">
          Vos no necesitás "otro consejo". <br data-id="element-182" />
          Necesitás una forma de bajar.
        </motion.p>
      </div>

      {/* Product Reveal */}
      <div className="max-w-4xl mx-auto bg-white rounded-3xl p-8 md:p-16 shadow-xl border border-terracotta/10 relative overflow-hidden" data-id="element-183">
        <div className="absolute top-0 right-0 w-64 h-64 bg-terracotta/5 rounded-full -translate-y-1/2 translate-x-1/2" data-id="element-184" />

        <div className="grid md:grid-cols-2 gap-12 items-center relative z-10" data-id="element-185">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="order-2 md:order-1" data-id="element-186">
            <span className="text-terracotta font-medium tracking-widest text-sm uppercase mb-2 block" data-id="element-187">
              Presentación
            </span>
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-charcoal mb-4" data-id="element-188">
              MIS MANOS, <br data-id="element-189" />
              MI CALMA
            </h2>
            <p className="text-xl text-terracotta-dark font-serif italic mb-6" data-id="element-190">
              El Interruptor de Pánico Somático en 3 Zonas
            </p>
            <p className="text-lg text-charcoal-light mb-8 leading-relaxed" data-id="element-191">
              Un PDF ultra-práctico para bajar activación en 10 minutos usando
              una secuencia simple:
              <br data-id="element-192" />
              <span className="font-medium text-charcoal block mt-2" data-id="element-193">
                Oreja → Mandíbula/Cuello → Pecho
              </span>
            </p>

            <div className="space-y-4 mb-8 text-sm text-charcoal-light" data-id="element-194">
              <p className="font-medium text-charcoal" data-id="element-195">Lo podés hacer:</p>
              <div className="flex flex-wrap gap-2" data-id="element-196">
                {['en el baño', 'en la cocina', 'en la cama', 'con tus hijos cerca'].map(tag => <span key={tag} className="bg-cream-200 px-3 py-1 rounded-full" data-id="element-197">
                    {tag}
                  </span>)}
              </div>
            </div>

            <CTAButton text="Conseguir el protocolo" data-id="element-198" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          rotate: -2
        }} whileInView={{
          opacity: 1,
          scale: 1,
          rotate: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="order-1 md:order-2 flex justify-center" data-id="element-199">
            <div className="relative" data-id="element-200">
              <div className="absolute inset-0 bg-terracotta/20 blur-2xl rounded-full transform scale-90" data-id="element-201" />
              <img src="https://cdn.magicpatterns.com/uploads/cdCa8MYjtx32Zn32AEtgc4/1.png" alt="Mis Manos, Mi Calma PDF en tablet" className="relative z-10 w-full max-w-sm rounded-lg shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-202" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}